<template>
	<div class="modal fade" tabindex="-1" id="findingCommentsModal">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<a href="#" class="close" data-dismiss="modal" aria-label="Close">
					<em class="icon ni ni-cross"></em>
				</a>
				<div class="modal-header">
					<h5 class="modal-title">
						<span
							class="badge badge-primary mr-2"
							:style="stateColorStyle(finding.last_state || finding.state)"
						>
							{{ finding.last_state || finding.state }}
						</span>
						Kommentare zu #{{ finding.pos }}
					</h5>
				</div>
				<div class="modal-body">
					<!-- Finding Text Preview -->
					<div class="finding-preview mb-3">
						<div class="finding-text" v-html="truncatedFindingText"></div>
					</div>

					<!-- Comments List -->
					<div class="comments-section">
						<div v-if="loading" class="text-center py-4">
							<div class="spinner-border spinner-border-sm" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>

						<div
							v-else-if="comments.length === 0"
							class="text-center py-4 text-muted"
						>
							Noch keine Kommentare vorhanden.
						</div>

						<div v-else class="comments-list">
							<div
								v-for="comment in comments"
								:key="comment.id"
								class="comment-item"
							>
								<div class="comment-avatar">
									<span class="material-icons">account_circle</span>
								</div>
								<div class="comment-content">
									<div class="comment-header">
										<span class="comment-author">{{ comment.user_name }}</span>
										<span class="comment-date">{{
											formatDate(comment.created_at)
										}}</span>
										<span
											class="comment-actions"
											v-if="canEditComment(comment)"
										>
											<button
												class="btn btn-sm btn-icon comment-edit-btn"
												@click="startEditComment(comment)"
												title="Bearbeiten"
											>
												<span class="material-icons">edit</span>
											</button>
											<button
												class="btn btn-sm btn-icon comment-delete-btn"
												@click="confirmDeleteComment(comment)"
												title="Löschen"
											>
												<span class="material-icons">delete</span>
											</button>
										</span>
									</div>
									<!-- Edit Mode -->
									<div
										v-if="editingCommentId === comment.id"
										class="comment-edit-form"
									>
										<textarea
											v-model="editCommentText"
											class="form-control"
											rows="2"
										></textarea>
										<div class="comment-edit-actions mt-2">
											<button
												class="btn btn-sm btn-primary"
												@click="saveEditComment(comment)"
											>
												Speichern
											</button>
											<button
												class="btn btn-sm btn-outline-secondary ml-1"
												@click="cancelEditComment"
											>
												Abbrechen
											</button>
										</div>
									</div>
									<!-- Display Mode -->
									<div v-else class="comment-text">{{ comment.text }}</div>
									<div
										v-if="
											comment.updated_at &&
												comment.updated_at !== comment.created_at
										"
										class="comment-edited"
									>
										(bearbeitet am {{ formatDate(comment.updated_at) }})
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Add Comment Form -->
					<div class="add-comment-section mt-4">
						<div class="add-comment-form">
							<textarea
								v-model="newCommentText"
								class="form-control"
								rows="3"
								placeholder="Kommentar schreiben..."
								@keydown.ctrl.enter="addComment"
								@keydown.meta.enter="addComment"
							></textarea>
							<div class="add-comment-actions mt-2">
								<span class="text-muted small">Strg+Enter zum Absenden</span>
								<button
									class="btn btn-primary"
									@click="addComment"
									:disabled="!newCommentText.trim() || submitting"
								>
									<span
										v-if="submitting"
										class="spinner-border spinner-border-sm mr-1"
									></span>
									Kommentieren
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light">
					<span class="text-muted small"
						>{{ comments.length }} Kommentar(e)</span
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getFindingComments,
	addFindingComment,
	updateFindingComment,
	deleteFindingComment,
} from '@/services/reporting-v3.service';

export default {
	props: {
		finding: {
			type: Object,
			required: true,
		},
		projectId: {
			type: String,
			required: true,
		},
		inspectId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			comments: [],
			newCommentText: '',
			loading: false,
			submitting: false,
			editingCommentId: null,
			editCommentText: '',
		};
	},
	computed: {
		truncatedFindingText() {
			const text = this.finding.text || '';
			if (text.length > 200) {
				return text.substring(0, 200) + '...';
			}
			return text;
		},
		currentUserId() {
			return this.$store.state.user_uid || null;
		},
	},
	mounted() {
		$('#findingCommentsModal').modal('show');

		const ref = this;
		$('#findingCommentsModal').on('hidden.bs.modal', function() {
			ref.$emit('dialogClosed', { commentsCount: ref.comments.length });
		});

		this.loadComments();
	},
	methods: {
		stateColorStyle(state) {
			return {
				background: this.$store.state.rp_state_color[state],
				'border-color': this.$store.state.rp_state_color[state],
			};
		},

		formatDate(dateString) {
			if (!dateString) return '';
			const date = new Date(dateString);
			const options = {
				year: 'numeric',
				month: 'short',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			};
			return date.toLocaleDateString('de-DE', options);
		},

		canEditComment(comment) {
			console.log(comment.user_id, this.currentUserId);
			return comment.user_id === this.currentUserId;
		},

		async loadComments() {
			this.loading = true;
			try {
				const response = await getFindingComments(
					this.projectId,
					this.inspectId,
					this.finding.id
				);
				if (response && response.data && response.data.comments) {
					this.comments = response.data.comments;
				}
			} catch (error) {
				console.error('Error loading comments:', error);
				this.$store.dispatch('api_error', error);
			} finally {
				this.loading = false;
			}
		},

		async addComment() {
			if (!this.newCommentText.trim() || this.submitting) return;

			this.submitting = true;
			try {
				const response = await addFindingComment(
					this.projectId,
					this.inspectId,
					this.finding.id,
					this.newCommentText.trim()
				);
				if (response && response.data && response.data.comment) {
					this.comments.push(response.data.comment);
					this.newCommentText = '';
				}
			} catch (error) {
				console.error('Error adding comment:', error);
				this.$store.dispatch('api_error', error);
			} finally {
				this.submitting = false;
			}
		},

		startEditComment(comment) {
			this.editingCommentId = comment.id;
			this.editCommentText = comment.text;
		},

		cancelEditComment() {
			this.editingCommentId = null;
			this.editCommentText = '';
		},

		async saveEditComment(comment) {
			if (!this.editCommentText.trim()) return;

			try {
				const response = await updateFindingComment(
					this.projectId,
					this.inspectId,
					this.finding.id,
					comment.id,
					this.editCommentText.trim()
				);
				if (response && response.data && response.data.comment) {
					const index = this.comments.findIndex((c) => c.id === comment.id);
					if (index !== -1) {
						this.$set(this.comments, index, response.data.comment);
					}
				}
				this.cancelEditComment();
			} catch (error) {
				console.error('Error updating comment:', error);
				this.$store.dispatch('api_error', error);
			}
		},

		async confirmDeleteComment(comment) {
			if (!confirm('Kommentar wirklich löschen?')) return;

			try {
				await deleteFindingComment(
					this.projectId,
					this.inspectId,
					this.finding.id,
					comment.id
				);
				this.comments = this.comments.filter((c) => c.id !== comment.id);
			} catch (error) {
				console.error('Error deleting comment:', error);
				this.$store.dispatch('api_error', error);
			}
		},
	},
};
</script>

<style scoped>
.finding-preview {
	background: #f8f9fa;
	border: 1px solid #e5e9f2;
	border-radius: 4px;
	padding: 12px;
}

.finding-text {
	font-size: 14px;
	color: #526484;
}

.comments-section {
	border-top: 1px solid #e5e9f2;
	padding-top: 15px;
	max-height: 400px;
	overflow-y: auto;
}

.comments-list {
	display: flex;
	flex-direction: column;
	gap: 15px;
}

.comment-item {
	display: flex;
	gap: 12px;
	padding-bottom: 15px;
	border-bottom: 1px solid #f0f0f0;
}

.comment-item:last-child {
	border-bottom: none;
}

.comment-avatar {
	flex-shrink: 0;
}

.comment-avatar .material-icons {
	font-size: 40px;
	color: #8094ae;
}

.comment-content {
	flex: 1;
	min-width: 0;
}

.comment-header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 4px;
}

.comment-author {
	font-weight: 600;
	color: #364a63;
	font-size: 14px;
}

.comment-date {
	font-size: 12px;
	color: #8094ae;
}

.comment-actions {
	margin-left: auto;
	display: flex;
	gap: 2px;
}

.comment-edit-btn,
.comment-delete-btn {
	padding: 2px 6px;
	opacity: 0.6;
	transition: opacity 0.2s;
}

.comment-edit-btn:hover,
.comment-delete-btn:hover {
	opacity: 1;
}

.comment-edit-btn .material-icons,
.comment-delete-btn .material-icons {
	font-size: 16px;
}

.comment-delete-btn {
	color: #e85347;
}

.comment-text {
	font-size: 14px;
	color: #526484;
	line-height: 1.5;
	white-space: pre-wrap;
	word-break: break-word;
}

.comment-edited {
	font-size: 11px;
	color: #8094ae;
	font-style: italic;
	margin-top: 2px;
}

.comment-edit-form textarea {
	font-size: 14px;
}

.add-comment-section {
	border-top: 1px solid #e5e9f2;
	padding-top: 15px;
}

.add-comment-form textarea {
	resize: none;
	font-size: 14px;
}

.add-comment-form textarea:focus {
	border-color: #6576ff;
	box-shadow: 0 0 0 3px rgba(101, 118, 255, 0.1);
}

.add-comment-actions {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.modal-footer {
	display: flex;
	justify-content: flex-end;
}
</style>
